/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Coaching_Student_SinceInputs */

const en_us2_coaching_student_since = /** @type {(inputs: Coaching_Student_SinceInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Student since ${i?.date}`)
};

const pt_br2_coaching_student_since = /** @type {(inputs: Coaching_Student_SinceInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Aluno desde ${i?.date}`)
};

const pt_pt2_coaching_student_since = /** @type {(inputs: Coaching_Student_SinceInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Aluno desde ${i?.date}`)
};

/** @type {(inputs: Coaching_Student_SinceInputs) => LocalizedString} */
const es_419_coaching_student_since = en_us2_coaching_student_since;

/** @type {(inputs: Coaching_Student_SinceInputs) => LocalizedString} */
const fr_fr2_coaching_student_since = en_us2_coaching_student_since;

/** @type {(inputs: Coaching_Student_SinceInputs) => LocalizedString} */
const de_de2_coaching_student_since = en_us2_coaching_student_since;

/** @type {(inputs: Coaching_Student_SinceInputs) => LocalizedString} */
const it_it2_coaching_student_since = en_us2_coaching_student_since;

/**
* | output |
* | --- |
* | "Student since {date}" |
*
* @param {Coaching_Student_SinceInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const coaching_student_since = /** @type {((inputs: Coaching_Student_SinceInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coaching_Student_SinceInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_coaching_student_since(inputs)
	if (locale === "es-419") return es_419_coaching_student_since(inputs)
	if (locale === "pt-PT") return pt_pt2_coaching_student_since(inputs)
	if (locale === "fr-FR") return fr_fr2_coaching_student_since(inputs)
	if (locale === "de-DE") return de_de2_coaching_student_since(inputs)
	if (locale === "it-IT") return it_it2_coaching_student_since(inputs)
	return en_us2_coaching_student_since(inputs)
});
export { coaching_student_since as "coaching.student_since" }